import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable({
  providedIn: 'root'
})

export class GetBillToInfoService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {

  }

  getBillToInfo(billToInfoId: string) {
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({  'Content-Type': 'application/json'    })
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

  
    var params = new HttpParams()

    return  this.httpClient.get(`${apiConfig.uri}/bill-to-infos/${billToInfoId}`, { headers: headers });
  }

}
